<template>
  <div v-if="isSupplier" class="page-item">
    <base-section-title>
      <template>
        标前狗会员服务
      </template>
    </base-section-title>
    <div class="flex m-l-32">
      <div
        v-for="item in list"
        :key="item.title"
        class="list-item"
        @click="goPage(item)"
      >
        <img :src="item.icon" class="icon" style="width: 64px; height: 64px;" />
        <div class="text">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import { mapState } from 'vuex'
import { toVipBuy } from '@/utils/platform'
import { workbenchServiceDict } from '@/dictionary/system'

export default {
  name: 'HomeMembershipService',

  components: {
    BaseSectionTitle
  },

  data() {
    return {
      workbenchServiceDict,
      list: [
        {
          title: '全网商机',
          icon: require('@/assets/images/home/MembershipService/notice.png'),
          url: process.env.VUE_APP_BIDDOG_URL + '/network-notice'
        },
        {
          title: '标讯订阅',
          icon: require('@/assets/images/home/MembershipService/subscription.png'),
          url: process.env.VUE_APP_BIDDOG_URL + '/subscription/list'
        },
        {
          title: '竞争对手分析',
          icon: require('@/assets/images/home/MembershipService/competitor.png'),
          url: process.env.VUE_APP_BIDDOG_URL + '/competitor-analysis/list'
        },
        {
          title: '采购单位分析',
          icon: require('@/assets/images/home/MembershipService/purchaser.png'),
          url: process.env.VUE_APP_BIDDOG_URL + '/purchaser-analysis/list'
        },
        {
          title: '数据定制导出',
          icon: require('@/assets/images/home/MembershipService/custom-data.png'),
          url: process.env.VUE_APP_BIDDOG_URL + '/custom-data/filter'
        },
        {
          title: '我的关注',
          icon: require('@/assets/images/home/MembershipService/follow.png'),
          url: process.env.VUE_APP_BIDDOG_URL + '/follow/project'
        }
      ]
    }
  },

  computed: {
    ...mapState('user', ['vipInfo']),
    ...mapState('router', ['currentWorkbench']),

    isVip() {
      return this.vipInfo.rightsId && !this.vipInfo.isExpire
    },
    isSupplier() {
      return this.currentWorkbench === workbenchServiceDict.SUPPLIER.value
    }
  },

  created() {},

  methods: {
    goPage(val) {
      window.onbeforeunload = null
      if (this.isVip) {
        if (val.url) {
          window.open(val.url, '_blank')
        }
      } else {
        toVipBuy()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-item {
  background: $white-color;
  margin: 0 8px 16px 8px;
  box-sizing: border-box;
  padding: 24px;
  .title-text {
    font-size: 14px;
    margin-left: 16px;
    color: #cb9d46;
  }
  .list-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 72px;
    align-items: center;
    margin-top: 24px;
    cursor: pointer;
    .text {
      font-size: 14px;
      color: $text-color;
      margin-right: 4px;
      margin-top: 16px;
    }
    .text2 {
      font-size: 14px;
      color: $text-color;
      margin-right: 24px;
      margin-top: 16px;
    }
  }
  .line {
    width: 1px;
    height: 108px;
    margin: 20px 90px 0 18px;
    background: $info-fourth-color;
  }
}
</style>
